export default "__VITE_ASSET__BM2qeKWt__"